"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Server response from a STREAM_ADD_TOPIC_SERVICE or STREAM_ADD_AND_SET_TOPIC_SERVICE request.
 */
var UpdateStreamAddTopicResponse = /** @class */ (function () {
    /**
     * Create a new UpdateStreamAddTopicResponse instance
     *
     * @param creationResult  the creation result
     * @param streamId  the update-stream ID
     * @param retainsValue  indicates if the topic retains a value
     * @param supportsConflation  indicates if the topic supports conflation
     */
    function UpdateStreamAddTopicResponse(creationResult, streamId, retainsValue, supportsConflation) {
        this.creationResult = creationResult;
        this.streamId = streamId;
        this.retainsValue = retainsValue;
        this.supportsConflation = supportsConflation;
    }
    return UpdateStreamAddTopicResponse;
}());
exports.UpdateStreamAddTopicResponse = UpdateStreamAddTopicResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/update-stream-add-topic-response.js
// module id = 2068
// module chunks = 1